import {ChangeDetectionStrategy, Component, inject, input} from '@angular/core';
import {ButtonAction} from "../../../../../types/button-action.types";
import {FeedbackMediaProps} from "../../types/feedback-media-modal.types";
import {defaultFeedbackMediaProps} from "../../configs/feedback-media-modal-config";
import {PreviewFilesStateService} from "../../../../../services/preview-files-state.service";
import {ModalsService} from "../../../../../services/modals.service";

@Component({
  selector: 'app-feedback-media-image',
  standalone: true,
  imports: [],
  templateUrl: './feedback-media-image.component.html',
  styleUrl: './feedback-media-image.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedbackMediaImageComponent {
  feedbackMediaProps = input<FeedbackMediaProps>(defaultFeedbackMediaProps);

  private previewFilesStateService: PreviewFilesStateService = inject(PreviewFilesStateService);
  private modalsService: ModalsService = inject(ModalsService);

  public async handleClick(buttonAction: ButtonAction, index: number): Promise<void> {
    if (buttonAction === 'open') {
      await this.modalsService.openPreviewFileModal({
        type: ['image', ''],
        fileId: index + 1,
        fileType: 'FEEDBACK',
        url: this.previewFilesStateService.getFileUrl(index + 1),
        isNeedArrow: true
      });
    }
  }
}
